export function LogoMark({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="url(#pulso-grad)" />
      <path
        d="M4 17 H10 L12.5 9.5 L16.5 23 L19.5 15.5 L21.5 18.5 H28"
        stroke="#ffffff"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id="pulso-grad" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6366f1" />
          <stop offset="1" stopColor="#4338ca" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Logo() {
  return (
    <div className="logo">
      <LogoMark size={26} />
      <span className="logo-word">Pulso</span>
    </div>
  );
}
